var _path, _path2, _mask, _g, _path3, _path4, _mask2, _g2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaser = function SvgLaser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "M20.1 31.907c-8.674 0-9.88-2.847-9.971-4.17-.112-1.64 1.335-3.143 3.162-3.282 5.83-.443 13.327-3.544 16.934-9.476 1.284-2.112 1.796-5.124.044-7.091-.626-.704-1.729-1.235-2.621-1.263q-.785-.023-1.24.43l-1.288-1.3c.666-.658 1.556-.994 2.584-.958 1.394.044 2.973.798 3.93 1.875 2.373 2.665 1.787 6.57.154 9.257-3.47 5.704-10.676 9.766-18.36 10.349-.8.06-1.518.71-1.475 1.334.073 1.05 2.454 2.898 10.97 2.374l.112 1.825q-1.593.097-2.936.096",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m12.688 28.955-.127.076z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "laser_svg__a",
    width: 25,
    height: 25,
    x: 5,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.6 2.914h23.61v23.987H5.6z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#laser_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m5.6 16.81 10.09 10.091c3.847-3.046 6.906-7.188 8.083-8.952 1.38-2.071 5.438-8.2 5.438-8.2l-6.835-6.835-13.5 9.15A7.17 7.17 0 0 0 5.602 16.8",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M14.739 27.62q-.044.031-.09.064.046-.032.09-.065M8.746 31.223l.154-.08z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "m3.373 27.029 3.971 3.97c.37.37.934.459 1.402.224.779-.39 2.237-1.197 4.878-2.85.71-.444 1.398-.944 2.067-1.472L5.6 16.81c-.742 3.831-2.047 9.518-2.228 10.215z",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "laser_svg__b",
    width: 6,
    height: 6,
    x: 2,
    y: 27,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 27.774h5.18v4.421H2z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#laser_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "m7.18 30.835-.823.824a1.833 1.833 0 0 1-2.592 0L2 29.894l2.12-2.12z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m18.655 17.812-5.2-5.198 8.642-5.884 3.457 3.457s-3.256 5.037-5.1 7.498a1.193 1.193 0 0 1-1.8.127",
    clipRule: "evenodd"
  })));
};
export default SvgLaser;